import script from "./Guides.vue?vue&type=script&setup=true&lang=js"
export * from "./Guides.vue?vue&type=script&setup=true&lang=js"

import "./Guides.vue?vue&type=style&index=0&id=7e7e294c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7e294c"]])

export default __exports__